import styled from 'styled-components'
import {
  background,
  hFlex,
  vFlex,
} from '../../../../../../../Styles/style-helpers'
import { darkAccent } from '../../../../../../../Styles/colors'

export const GroupCourseDashboardEl = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 5em);
  overflow: auto;
  ${vFlex};
  justify-content: flex-start;

  .content {
    ${hFlex};
    flex: 1;
    height: 100%;
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: auto;
    padding: 1em 1em 0;

    .activeBatchDetails {
      flex: 1;
      width: 100%;
      height: 100%;
      overflow: auto;
      ${hFlex};
      background: #ffffff;
      box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.25);
      border-top-left-radius: 1em;
      border-top-right-radius: 1em;
    }
  }
`

export const HeaderEl = styled.div`
  ${hFlex};
  width: calc(100% - 2em);
  justify-content: flex-start;
  padding: 1.5em;
  background: #e7e7e7;
  border-radius: 1em;
  margin: 1em;

  .cover {
    width: 7.5em;
    height: ${(7.5 * 9) / 16}em;
    ${({ cover }) => background(cover, 'cover')};
    margin-right: 1em;
    border-radius: 0.5em;
    cursor: pointer;
  }

  .info {
    ${vFlex};
    align-items: unset;
    height: 100%;

    h4 {
      text-transform: capitalize;
      cursor: pointer;
    }

    h6 {
      span {
        color: ${darkAccent};
        cursor: pointer;
      }
    }
  }
`
